import { render, staticRenderFns } from "./AdminLedger.vue?vue&type=template&id=3f5e5e3a&scoped=true&"
import script from "./AdminLedger.vue?vue&type=script&lang=js&"
export * from "./AdminLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e5e3a",
  null
  
)

export default component.exports